import React, { Fragment } from 'react';

const LoadingDraft = ({ title = '' }) => (
    <Fragment>
        <div className="page-top flex-none" />
        <div className="column-inner scrollable-column flex-auto sm-px4 page-content-container">
            <div className="editor-content-column">
                <div className="container container-small relative">
                    <div className="post-html">
                        <h1 className="page-title mb1">{title}</h1>
                        <div id="post-editor-content" className="post-editor-content">
                            <span className="gray loading">Loading draft</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Fragment>
);

export default LoadingDraft;
